// Packages Enums
export const RealTimeInventoryManagement = '5';
export const ReportingAndAnalytics = '7';
export const UnlimitedProductsUsers = '10';
export const Promotions = '11';